import { styled } from "../../../../styles";

export const ModalContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  padding: "24px 26px",
});

export const Title = styled("p", {
  color: "$black",
  fontFamily: "$openSans",
  fontSize: "16px",
  lineHeight: "22px",
  fontWeight: "600",
  marginBottom: "16px",
});

export const Message = styled("p", {
  color: "$charcoal",
  fontFamily: "$openSans",
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: "400",
  marginBottom: "24px",
});

export const ButtonContainer = styled("div", {
  display: "flex",
  justifyContent: "flex-start",
});
